import { Component, Input, OnInit } from '@angular/core';
import { TextSearchPattern } from '../../../models/net/text-search-pattern';

@Component({
    selector: 'app-text-search-field',
    templateUrl: './text-search-field.component.html',
    styleUrls: ['./text-search-field.component.css', '../../../app.component.css']
})

export class TextSearchFieldComponent implements OnInit {

    public isPrefixWild: boolean = false;
    public isSuffixWild: boolean = false;

    @Input() public label: string = "";
    @Input() public placeholder: string = "";
    @Input() public textSearchPattern: TextSearchPattern = new TextSearchPattern();
    @Input() class: string = '';

    public constructor() { }

    public ngOnInit(): void {

        this.isPrefixWild = true;
        this.isSuffixWild = true;
    }

    public toggleWildcardPrefix = (): void => {

        this.textSearchPattern!.IsWildPrefix = !this.textSearchPattern!.IsWildPrefix;
    }

    public toggleWildcardSuffix = (): void => {

        this.textSearchPattern!.IsWildSuffix = !this.textSearchPattern!.IsWildSuffix;
    }
}
